module.exports = __webpack_public_path__ + "static/media/money-bag-symbol.1f56c6fe.png";